import { MatDialog } from '@angular/material/dialog';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from '@tech-services/common.service';
import {
  ClientDataApiRestInterface,
  PortfolioInterface,
  PortfolioDataInterface,
  DeviceDetectorService,
} from '@techrules/portallib';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { takeUntil } from 'rxjs/operators';
import { AppConfig } from '@tech-utils/app-config.service';
import {
  faEllipsisV,
  faFileChartLine,
  faSignIn,
  faSignOut,
} from '@fortawesome/pro-light-svg-icons';
import { environment } from '@tech-environments/environment';
import { SessionService } from '../../../core/services/session.service';
import { Router } from '@angular/router';

import { formatDate } from '@angular/common';
import { TechDialogsService } from '../../../shared/tech-dialogs.service';
import { TechModalRiskProfileExpireComponent } from '../../../shared/techmodalRiskProfileExpire/techmodalRiskProfileExpire.component';
import { ModalCustomDateReportComponent } from '../../../shared/modal-custom-date-report/modal-custom-date-report.component';

@Component({
  selector: 'tech-profileportfolio',
  templateUrl: './profileportfolio.component.html',
  styleUrls: ['./profileportfolio.component.scss'],
})
export class ProfilePortfolioComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private noPortfoliosSubscription: Subscription;

  faFileChartLine = faFileChartLine;
  faSignIn = faSignIn;
  faSignOut = faSignOut;
  faEllipsisV = faEllipsisV;
  portfolios: PortfolioInterface[];
  //portfolio: portfolioInterface;
  portfolioCode: string;
  portfolioServiceModelCode: string;
  noPortofolios: boolean = false;
  stepOK: boolean = false;
  option1: boolean;
  dateFormat: string = this.sessionService.dateFormat
    .replace('DD', 'dd')
    .replace('YYYY', 'yyyy')
    .replace('MMM', 'MM');
  portfolioData: PortfolioDataInterface;
  portfolioDataItem: PortfolioDataInterface;

  allowOperations: any;
  portfolioanalysis;
  allowContributions = false;
  allowWithdrawals = false;
  version: string;
  isMovil: boolean;
  logoUrl =
    './assets/img/' +
    localStorage.getItem('ThemeImg') +
    '/WealthRules-265px.png';
  alias: any;
  aliasabreviado: string;
  isback: boolean = false;
  reportWithDate: boolean = AppConfig.settings.reportWithDate;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private deviceService: DeviceDetectorService,
    private commonService: CommonService,
    private translate: TranslateService,
    private profilePortfolioService: ProfileportfolioService,
    private sessionService: SessionService,
    private dialogService2: TechDialogsService
  ) {}

  verifyTestModal() {
    const dialogRef = this.dialog.open(TechModalRiskProfileExpireComponent);
  }

  ngOnInit() {
    this.isMovil = this.deviceService.isMobile();
    this.version = environment.appVersion;
    this.commonService.showMenuSource.next(true);
    this.commonService.loading$.emit(true);
    this.commonService.isProductiveSource.next(true);

    this.commonService.clientDataInitialSource
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: ClientDataApiRestInterface) => {
        if (Object.keys(data).length > 0) {
          const _investorProfile = data.InvestorProfile;
          // console.log(_investorProfile);
          if (_investorProfile.TestExpired) {
            this.verifyTestModal();
          }
        }
      });

    this.profilePortfolioService.portfolioData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        //this.option1 = data.ServiceModelCode === 'RO';
        this.allowOperations = data ? data.AllowOperations : null;
        this.allowContributions = this.allowOperations
          ? data.AllowOperations.AllowContribution
          : false;
        this.allowWithdrawals = this.allowOperations
          ? data.AllowOperations.AllowWithdrawal
          : false;
      });

    this.translate.get('k000256').subscribe((text: string) => {
      this.commonService.setTitle(text + ' | ' + AppConfig.settings.tabTitle);
    });

    this.noPortfoliosSubscription = this.commonService.noPortfolios$.subscribe(
      (val) => {
        //this.noPortofolios = val;
      }
    );

    this.commonService.portfolioCodeSource.next(
      this.sessionService.portfolioCode
    );
    this.profilePortfolioService.getPortfolioData().subscribe((data) => {
      // console.log(data);
      this.portfolioData = data;
      const numPortfolios = parseInt(localStorage.getItem('numPortfolios'));

      if (localStorage.getItem('OnboardingType') == 'Linear' && numPortfolios == 1 && !AppConfig.settings.favoritesOnDashboard) {
        this.isback = false;
      } else {
        this.isback = true;
      }

      this.portfolioCode = this.portfolioData.PortfolioCode;
      this.sessionService.portfolioCode = this.portfolioData.PortfolioCode;
      //this.operativeData.portfolioCode = this.portfolioData.PortfolioCode;
      this.noPortofolios = false;
      this.alias = this.portfolioData.Alias
        ? this.portfolioData.Alias.length > 20
          ? this.portfolioData.Alias.slice(0, 18) + '...'
          : this.portfolioData.Alias
        : '';
      this.aliasabreviado = this.portfolioData.Alias
        ? this.portfolioData.Alias.substring(0, 2).toUpperCase()
        : '';

      this.commonService.stepOK$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((val) => {
          this.stepOK = val;
        });

      this.stepOK = true;
      this.profilePortfolioService.portfolioDataSource.next(data);
      this.commonService.loading$.emit(false);
    });

    this.profilePortfolioService.portfolioanalysis$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        this.portfolioanalysis = data;
        if (this.portfolioData != undefined) {
          this.portfolioData.ProfitLoss =
            this.portfolioanalysis.TotalProfitLossBeetweenDates;
          this.portfolioData.ProfitLossPercent =
            this.portfolioanalysis.PerformanceBeetweenDates;
          this.portfolioData.TotalProfitLossBeetweenDatesPercent =
            this.portfolioanalysis.TotalProfitLossBeetweenDatesPercent;
        }
      });

    this.commonService.chatListener$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {});
  }

  @HostListener('window:resize') onresize() {
    this.isMovil = this.deviceService.isMobile();
  }

  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  goMessage(id, item) {
    const text1 = this.translate.instant('k003469'); //Token: Unable to complete operation
    const text2 = this.translate.instant('k003470'); //Token: Sorry, we cannot complete your operation at this time. This could be due to following reasons:
    const text3 = this.translate.instant('k003472'); //Token: Thank you for your understanding.
    const msg1 = this.allowOperations.MessageContribution;
    const msg2 = this.allowOperations.MessageWithdrawal;

    if (id == 1) {
      this.dialogService2.openModalDialog(
        '',
        text1,
        text2 + '</br> </br>' + msg1 + '</br></br>' + text3,
        ''
      );
    } else {
      this.dialogService2.openModalDialog(
        '',
        text1,
        text2 + '</br> </br>' + msg2 + '</br></br>' + text3,
        ''
      );
    }
  }

  // Funcion para lanzar el modal de fechas que se desea el informe
  public openDialog() {
    const dialogRef = this.dialog.open(ModalCustomDateReportComponent, {
      data: {
        initialDate:
          this.profilePortfolioService.periodSelectedSource.value
            .PeriodInitialtDate,
        endDate:
          this.profilePortfolioService.periodSelectedSource.value.PeriodEndDate,
        minDate: this.portfolioData.InitialDate,
        maxDate: this.portfolioData.AnalysisDate,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let customPeriod = {
          Name: 'Personalizado',
          Period: 'PeriodCustomOK',
          PeriodEndDate: formatDate(result.endDate, 'yyyy-MM-dd', 'en_GR'),
          PeriodInitialtDate: formatDate(
            result.initialDate,
            'yyyy-MM-dd',
            'en_GR'
          ),
        };
        this.profilePortfolioService.periodSelectedSource.next(customPeriod);
        this.openPdf();
      }
    });
  }

  /*
  Función para generar PDF de la cartera
  */
  openPdf() {
    localStorage.setItem('OpenPdf', 'portfolioreport');
    localStorage.setItem('PortfolioCode', this.portfolioData.PortfolioCode);
    localStorage.setItem(
      'InitialDate',
      this.profilePortfolioService.periodSelectedSource.value.PeriodInitialtDate
    );
    localStorage.setItem(
      'EndDate',
      this.profilePortfolioService.periodSelectedSource.value.PeriodEndDate
    );
    let url = window.location.href.replace('/profileportfolio', '');
    window.open(url + '/openpdf', '_blank');
  }

  goBack() {
    this.router.navigate(['/portfolios']);
  }

  /*
  goOperativeModal() {
    const dialogRef = this.dialog.open(OperativeModalComponent, {
      data: {
        portfolioCode: this.portfolioCode,
        allowOperations: this.allowOperations,
      },
    });
  }
*/
}
